import { createFeatureActionNamer } from '../redux/action-name';

const getActionName = createFeatureActionNamer('retrospective-underwriting-decision');

export const ADD_FINAL_DECISION = getActionName('ADD_FINAL_DECISION');
